
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/forms/form14";
const form14State = namespace("Form14");

import Form14ProcessHeader from "@/components/process/Form14/components/Form14ProcessHeader.vue";
import Spinner from "@/components/utils/Spinner.vue";
import { packageInfoType } from '@/types/Information';
import { form14StatusInfoType } from '@/types/Information/Form14';

@Component({
    components:{
        Form14ProcessHeader,
        Spinner
    }
})
export default class SubmitForm14 extends Vue {

    @form14State.State
    public currentConsentOrderRemoveInactiveId: string;

    stepsCompleted = {} as form14StatusInfoType;  
    mountedData = false; 
    packageInfo = {} as packageInfoType;
    submitting = false;
    errorMsg=""

    mounted() {
        this.mountedData = false;    
        this.submitting = false;    
        this.errorMsg = ""
        this.stepsCompleted = {
            first: true,
            second: true,
            third: false
        }
        this.mountedData = true;         
    }    

    public savePdf(){        
        const pdfType = "FORM"
        const pdfName ="Form14"
        const url = '/form14/form-print/'+this.currentConsentOrderRemoveInactiveId+'/?pdf_type='+pdfType
        const options = {
            responseType: "blob",
            headers: {
            "Content-Type": "application/json",
            }
        }
        this.$http.get(url, options)
        .then(res => {
            const blob = res.data;
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.download = pdfName+".pdf";
            link.click();
            setTimeout(() => URL.revokeObjectURL(link.href), 1000);          

        },err => {
            console.error(err);
        });
    }     

    public cancel() {
        this.$router.push({name: "dashboard" }) 
    }
}
